// frontend/src/pages/UserAdminPage.js
// Componente principal para la página de administración de usuarios.

import React, { useState } from 'react';
import UserList from '../components/UserList';
import UserForm from '../components/UserForm';
import { ArrowLeftIcon, UserGroupIcon } from '@heroicons/react/24/solid';

/**
 * @component UserAdminPage
 * @description Página para gestionar usuarios. Permite ver, añadir, editar y eliminar usuarios.
 * @param {object} props - Propiedades del componente.
 * @param {function} props.onBack - Callback para volver a la pantalla principal del dashboard.
 */
function UserAdminPage({ onBack }) {
  const [currentView, setCurrentView] = useState('list'); // 'list', 'add', 'edit'
  const [userToEdit, setUserToEdit] = useState(null);

  // Navegar a la vista de lista de usuarios
  const showUserList = () => {
    setCurrentView('list');
    setUserToEdit(null);
  };

  // Navegar al formulario para añadir un nuevo usuario
  const showAddUserForm = () => {
    setCurrentView('add');
    setUserToEdit(null);
  };

  // Navegar al formulario para editar un usuario existente
  const showEditUserForm = (user) => {
    setUserToEdit(user);
    setCurrentView('edit');
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-xl w-full max-w-4xl mx-auto my-8">
      <div className="flex justify-between items-center mb-6 border-b pb-4">
        <h2 className="text-3xl font-extrabold text-gray-900 flex items-center">
          <UserGroupIcon className="h-8 w-8 mr-3" />
          Gestión de Usuarios
        </h2>
        <button
          onClick={onBack}
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 flex items-center space-x-2 transition-colors"
        >
          <ArrowLeftIcon className="h-5 w-5" />
          <span>Volver</span>
        </button>
      </div>

      {currentView === 'list' && (
        <UserList
          onAddUser={showAddUserForm}
          onEditUser={showEditUserForm}
        />
      )}

      {(currentView === 'add' || currentView === 'edit') && (
        <UserForm
          userToEdit={userToEdit}
          onSuccess={showUserList}
          onCancel={showUserList}
        />
      )}
    </div>
  );
}

export default UserAdminPage;
